export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/main.worker.938f691a.worker.js");
}
